// import React, { memo } from "react";
// import DropdownTreeSelect from "react-dropdown-tree-select";

// const Container = memo(({ data, onChange, ...rest }) => {
//   return <DropdownTreeSelect data={data} onChange={onChange} {...rest} />;
// }, (prevProps, nextProps) => {
//   return JSON.stringify(prevProps.data) === JSON.stringify(nextProps.data) &&
//          prevProps.onChange === nextProps.onChange;
// });

// export default Container;



import React, { Component } from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import isEqual from 'lodash/isEqual'
import "./DropdownTreeSelect.scss"

export default class Container extends Component {
  constructor(props){
    super(props)
    this.state = { data: props.data }
  }

  componentWillReceiveProps = (nextProps) => {
    if(!isEqual(nextProps.data, this.state.data)) {
      this.setState({ data: nextProps.data })
    }
  }

  shouldComponentUpdate = (nextProps) => {
    return !isEqual(nextProps.data, this.state.data)
  }

  render() {
    const { data,onChange, ...rest } = this.props;
    return (
      <DropdownTreeSelect data={this.state.data} onChange={onChange} {...rest} />
    )
  }
}
